module.exports = __webpack_public_path__ + "img/contact-light.1e422d45.png";